import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { Container, Table, Form, Button } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiGetOrgunits } from "../../api/ApiOrgunit";
import { FaTag } from "react-icons/fa";
import {
  MdOutlineEdit,
  MdDeleteOutline,
  MdAddCircleOutline,
  MdPeople,
  MdManageAccounts,
} from "react-icons/md";
import ModalCreateUpdate from "../../components/admin/orgunit/ModalCreateUpdate";
import ModalDelete from "../../components/admin/orgunit/ModalDelete";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";
import { BiHide, BiShow, BiSubdirectoryRight } from "react-icons/bi";
import ModalChoixPersonnes from "../../components/admin/orgunit/ModalChoixPersonnes";
import ModalChoixEngagements from "../../components/admin/orgunit/ModalChoixEngagements";
import ModalChoixProcesses from "../../components/admin/orgunit/ModalChoixProcesses";
import { useTranslation } from "react-i18next";
import { RiFilterOffLine } from "react-icons/ri";

const PageAdminOrgunits = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();

  const [orgunitPrincipalInOperation, setOrgunitPrincipalInOperation] = useState({
    orgunitPrincipalInOperation: ReduxInstance.orgunitPrincipalInOperation,
  });

  const [orgunits, setOrgunits] = useState([]);
  const [orgunitSelectionne, setOrgunitSelectionne] = useState(null);

  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showPersonnes, setShowPersonnes] = useState(false);
  const [showProcesses, setShowProcesses] = useState(false);
  const [showEngagements, setShowEngagements] = useState(false);
  const [filtres, setFiltres] = useState({ nom: "", type: "" });

  const [idOrgunit, setIdOrgunit] = useState("");

  const [loader, setLoader] = useState(false);

  const handleShowCreateUpdate = (id) => {
    setIdOrgunit(id);
    setShowCreateUpdate(true);
  };
  const handleCloseCreateUpdate = () => {
    setIdOrgunit(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdOrgunit(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdOrgunit(null);
    setShowDelete(false);
  };

  const handleShowPersonnes = (id, nom) => {
    setOrgunitSelectionne(nom);
    setIdOrgunit(id);
    setShowPersonnes(true);
  };

  const handleClosePersonnes = () => {
    setOrgunitSelectionne(null);
    setIdOrgunit(null);
    setShowPersonnes(false);
  };

  const handleShowEngagements = (id, nom) => {
    setOrgunitSelectionne(nom);
    setIdOrgunit(id);
    setShowEngagements(true);
  };

  const handleCloseEngagements = () => {
    setOrgunitSelectionne(null);
    setIdOrgunit(null);
    setShowEngagements(false);
  };

  const handleShowProcesses = (id, nom) => {
    setOrgunitSelectionne(nom);
    setIdOrgunit(id);
    setShowProcesses(true);
  };

  const handleCloseProcesses = () => {
    setOrgunitSelectionne(null);
    setIdOrgunit(null);
    setShowProcesses(false);
  };

  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(ReduxInstance._id);
    if (res) {
      setOrgunits(res.data);
    }
  };

  const submitData = async (e) => {
    setLoader(true);
    e.preventDefault();
    await apiUpdateInstance(ReduxInstance._id, orgunitPrincipalInOperation);

    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    dispatch(chgInstance(res.data));
    setLoader(false);
  };

  const getTradType = (type) => {
    switch (type) {
      case "Rituel":
        return t("commun.form.select.rituel");

      case "Rôle":
        return t("commun.form.select.role");

      case "Temps collectif":
        return t("commun.form.select.tempsCollectif");

      case "Partie prenante":
        return t("commun.form.select.partiePrenante");

      case "Mission":
        return t("commun.form.select.mission");

      default:
        return null;
    }
  };

  useEffect(() => {
    recupOrgunits();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const RecursiveComponentLigneTableau = ({ objet, childrens, niveau }) => {
    let hasChildren = false;
    if (childrens && childrens.length) hasChildren = true;

    // debut de mes filtres
    // si j'ai un filtre demandé sur le nom du OrgUnit
    if (filtres.nom) {
      const searchString = filtres.nom.toUpperCase();
      const nomParent = objet.nom.toUpperCase();

      // Si il a des enfants, on regarde si ce filtre matche dans ses enfants. Si ca matche, on garde le parent et on renvoi les enfants filtrés pour la boucle dessous
      const enfantsFiltrableNom = childrens.filter((children) => {
        const nomChildren = children.nom.toUpperCase();
        if (nomChildren.includes(searchString)) {
          return true;
        }
        return false;
      });
      if (!enfantsFiltrableNom.length) {
        // si aucun de ses enfants ne match, on va quand meme regarder si sur lui ca amtche pour le conserver le cas echeant
        if (!nomParent.includes(searchString)) {
          return false;
        }
      } else {
        childrens = enfantsFiltrableNom;
      }
    }

    // si j'ai un filtre demandé sur le type d'orgunit
    if (filtres.type) {
      // Si il a des enfants, on regarde si ce filtre matche dans ses enfants. Si ca matche, on garde le parent et on renvoi les enfants filtrés pour la boucle dessous
      const enfantsFiltrableType = childrens.filter((children) => {
        if (children.type.includes(filtres.type)) {
          return true;
        }
        return false;
      });
      if (!enfantsFiltrableType.length) {
        // si aucun de ses enfants ne match, on va quand meme regarder si sur lui ca amtche pour le conserver le cas echeant
        if (!objet.type.includes(filtres.type)) {
          return false;
        }
      } else {
        childrens = enfantsFiltrableType;
      }
    }
    // fin  de mes filtres

    return (
      <>
        <tr>
          <td>
            {niveau !== 0 && (
              <BiSubdirectoryRight
                size="1.5em"
                className={"text-danger"}
                style={{ marginLeft: niveau * 15 + "px" }}
              />
            )}
            {objet.nom}
          </td>
          <td className="text-center">{objet.type ? getTradType(objet.type) : "-"}</td>
          <td className="text-center">
            {objet.enSommeil ? (
              <BiHide size="1.5em" className="orgunitAdminHiddenButton" />
            ) : (
              <BiShow size="1.5em" />
            )}
          </td>

          <td className="text-center">
            <MdManageAccounts
              size="1.5em"
              role="button"
              onClick={() => handleShowProcesses(objet._id, objet.nom)}
            />
          </td>
          <td className="text-center">
            <MdPeople
              size="1.5em"
              role="button"
              onClick={() => handleShowPersonnes(objet._id, objet.nom)}
            />
          </td>
          <td className="text-center">
            <FaTag
              size="1em"
              role="button"
              onClick={() => handleShowEngagements(objet._id, objet.nom)}
            />
          </td>
          <td className="text-center">
            <MdOutlineEdit
              size="1.5em"
              role="button"
              onClick={() => handleShowCreateUpdate(objet._id)}
            />
          </td>
          <td className="text-center">
            <MdDeleteOutline
              size="1.5em"
              role="button"
              onClick={() => handleShowDelete(objet._id)}
            />
          </td>
        </tr>
        {hasChildren &&
          childrens.map((enfant) => (
            <RecursiveComponentLigneTableau
              key={enfant._id}
              objet={enfant}
              childrens={orgunits.filter((item) => item.orgUnitParent === enfant._id)}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminOrgunits.titre")} />
        <label className="fw-bold mt-2">{t("admin.PageAdminOrgunits.textExplication")}</label>
        <Form onSubmit={submitData}>
          <Form.Select
            name="orgunitPrincipalInOperation"
            value={orgunitPrincipalInOperation.orgunitPrincipalInOperation}
            onChange={(e) =>
              setOrgunitPrincipalInOperation({
                orgunitPrincipalInOperation: e.target.value || null,
              })
            }
          >
            <option value="">{t("commun.form.placeholder.selectionnerOrgunit")}</option>
            {orgunits
              .filter((item) => !item.enSommeil)
              .map((orgunit, index) => (
                <option value={orgunit._id} key={"orgunitPrincipal_" + index}>
                  {orgunit.nom}
                </option>
              ))}
          </Form.Select>

          <div className="text-end mt-2 mb-3">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" /> {t("admin.PageAdminOrgunits.buttonAjouterOrgunit")}
        </span>

        <Table striped bordered hover className="stickyTable mt-2">
          <thead className="align-top">
            <tr>
              <th>
                <div className="d-flex align-items-center">
                  {t("admin.PageAdminOrgunits.titreColonne1")}
                  {filtres.nom ? (
                    <RiFilterOffLine
                      size="1.5em"
                      role="button"
                      className="ms-1"
                      onClick={() => setFiltres({ ...filtres, nom: "" })}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <Form.Control
                  type="text"
                  name="nom"
                  value={filtres.nom}
                  placeholder={t("commun.form.placeholder.rechercher")}
                  onChange={(e) => setFiltres({ ...filtres, [e.target.name]: e.target.value })}
                />
              </th>

              <th className="text-center">
                <div className="d-flex align-items-center">
                  {t("admin.PageAdminOrgunits.titreColonne2")}
                  {filtres.type ? (
                    <RiFilterOffLine
                      size="1.5em"
                      role="button"
                      className="ms-1"
                      onClick={() => setFiltres({ ...filtres, type: "" })}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <Form.Select
                  name="type"
                  value={filtres.type}
                  onChange={(e) => setFiltres({ ...filtres, [e.target.name]: e.target.value })}
                >
                  <option value=""></option>
                  <option value="Rituel">{t("commun.form.select.rituel")}</option>
                  <option value="Rôle">{t("commun.form.select.role")}</option>
                  <option value="Temps collectif">{t("commun.form.select.tempsCollectif")}</option>
                  <option value="Partie prenante">{t("commun.form.select.partiePrenante")}</option>
                  <option value="Mission">{t("commun.form.select.mission")}</option>
                </Form.Select>
              </th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne7")}</th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne3")}</th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne4")}</th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne10")}</th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne5")}</th>
              <th className="text-center">{t("admin.PageAdminOrgunits.titreColonne6")}</th>
            </tr>
          </thead>
          <tbody>
            {/* ORGUNITS LEVEL 0 */}
            {orgunits
              .filter((orgunit) => orgunit.orgUnitParent === null)
              .map((orgunit) => (
                <RecursiveComponentLigneTableau
                  key={orgunit._id}
                  objet={orgunit}
                  childrens={orgunits.filter((item) => item.orgUnitParent === orgunit._id)}
                  niveau={0}
                />
              ))}
          </tbody>
        </Table>
        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idOrgunit}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupOrgunits}
          orgUnits={orgunits}
        />
        <ModalDelete
          show={showDelete}
          id={idOrgunit}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupOrgunits}
          orgUnits={orgunits}
        />
        <ModalChoixPersonnes
          show={showPersonnes}
          idOrgUnit={idOrgunit}
          orgunitName={orgunitSelectionne}
          handleClose={handleClosePersonnes}
          ReduxInstanceId={ReduxInstance._id}
        />
        <ModalChoixProcesses
          show={showProcesses}
          idOrgUnit={idOrgunit}
          orgunitName={orgunitSelectionne}
          handleClose={handleCloseProcesses}
          ReduxInstanceId={ReduxInstance._id}
        />
        <ModalChoixEngagements
          show={showEngagements}
          idOrgUnit={idOrgunit}
          orgunitName={orgunitSelectionne}
          handleClose={handleCloseEngagements}
          ReduxInstanceId={ReduxInstance._id}
        />
      </Container>
    </>
  );
};

export default PageAdminOrgunits;
